import type { ReactNode } from 'react'
import { getTopPadding } from '../../../utils/sessionStorage'
import { useElitePlansIsFromHome } from '../hooks/useElitePlansIsFromHome'
import { ElitePlansSellLandingChrome } from './ElitePlansSellLandingChrome'
import { ElitePlansHeader } from './ElitePlansHeader'
import { ElitePlansTabPanel } from './ElitePlansTabPanel'

export function ElitePlansTabbedPageLayout({ children }: { children: ReactNode }) {
  // Native home embed already has chrome — skip webview header, keep status-bar pad
  const hideHeader = useElitePlansIsFromHome()

  return (
    <ElitePlansSellLandingChrome>
      {hideHeader ? (
        <div
          className='ep-hero-zone bg-[color:var(--ep-bg-top)]'
          style={{ paddingTop: `${getTopPadding()}px` }}
          aria-hidden
        />
      ) : (
        <ElitePlansHeader />
      )}
      <ElitePlansTabPanel>{children}</ElitePlansTabPanel>
    </ElitePlansSellLandingChrome>
  )
}
